import React from 'react'
import { Box, withStyles } from '@material-ui/core'
import { styles } from './style'

const SymbolsCounter = ({ valueToCounter, symbolLimit, classes }) => {
  return (
    <Box className={classes.inputLength}>
      {`Symbols: ${
        valueToCounter ? valueToCounter.length : 0
      } of ${symbolLimit}`}
    </Box>
  )
}

export default withStyles(styles)(SymbolsCounter)
